var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0964 12C18.0964 11.6217 18.4112 11.315 18.7996 11.315H20.2802C19.9416 7.39556 16.7256 4.26207 12.7031 3.93213V5.37485C12.7031 5.75321 12.3883 6.05995 12 6.05995C11.6116 6.05995 11.2968 5.75321 11.2968 5.37485V3.93213C7.2743 4.26207 4.05835 7.39556 3.71973 11.315H5.20037C5.58868 11.315 5.90349 11.6217 5.90349 12C5.90349 12.3784 5.58868 12.6851 5.20037 12.6851H3.71973C4.05835 16.6045 7.2743 19.738 11.2968 20.068V18.6252C11.2968 18.2469 11.6116 17.9402 12 17.9402C12.3883 17.9402 12.7031 18.2469 12.7031 18.6252V20.068C16.7256 19.738 19.9416 16.6045 20.2802 12.6851H18.7996C18.4112 12.6851 18.0964 12.3784 18.0964 12ZM16.2464 8.72853L12.504 12.4777C12.2435 12.7387 11.8188 12.7557 11.5372 12.5158L8.74355 10.1362C8.45119 9.88721 8.42138 9.45437 8.67699 9.16955C8.93255 8.88469 9.37674 8.85555 9.66915 9.10465L11.9608 11.0567L15.2384 7.77319C15.5091 7.50198 15.9543 7.496 16.2326 7.75972C16.511 8.02361 16.5172 8.45733 16.2464 8.72853Z",
    fill: "url(#paint0_linear_444_34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.307617C5.38317 0.307617 0 5.55276 0 11.9999C0 18.4471 5.38317 23.6922 12 23.6922C18.6168 23.6922 24 18.4471 24 11.9999C24 5.55276 18.6168 0.307617 12 0.307617ZM12 21.4673C6.64228 21.4673 2.28347 17.2203 2.28347 11.9999C2.28347 6.77958 6.64228 2.53254 12 2.53254C17.3577 2.53254 21.7165 6.77958 21.7165 11.9999C21.7165 17.2203 17.3577 21.4673 12 21.4673Z",
    fill: "url(#paint1_linear_444_34)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_34",
    x1: 12,
    y1: 3.93213,
    x2: 12,
    y2: 20.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#0068FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_444_34",
    x1: 12,
    y1: 0.307617,
    x2: 12,
    y2: 23.6922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#0068FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF",
    stopOpacity: 0.69
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e54cc603757609298bfefd2c52555cf0.svg";
export { ForwardRef as ReactComponent };